<template>
  <div class="meal-slot-segment" role="tablist" :aria-label="ariaLabel">
    <button
      v-for="opt in normalizedOptions"
      :key="String(opt.value)"
      type="button"
      role="tab"
      class="meal-slot-segment-btn"
      :class="{ active: value === opt.value }"
      :aria-selected="value === opt.value"
      @click="onSelect(opt.value)"
    >
      {{ opt.label }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'MealSlotSegment',
  props: {
    value: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: null
    },
    ariaLabel: {
      type: String,
      default: '餐次筛选'
    }
  },
  computed: {
    normalizedOptions() {
      if (Array.isArray(this.options) && this.options.length) {
        return this.options.map((o) =>
          typeof o === 'string' ? { label: o, value: o === '全部' ? '' : o } : o
        )
      }
      return [
        { label: '全部', value: '' },
        { label: '午餐', value: '午餐' },
        { label: '晚餐', value: '晚餐' }
      ]
    }
  },
  methods: {
    onSelect(val) {
      if (val !== this.value) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    }
  }
}
</script>

<style scoped>
.meal-slot-segment {
  display: inline-flex;
  align-items: stretch;
  padding: 3px;
  border-radius: 999px;
  background: #f1f5f9;
  gap: 2px;
}

.meal-slot-segment-btn {
  flex: 1 1 0;
  min-width: 72px;
  height: 36px;
  padding: 0 20px;
  border: none;
  border-radius: 999px;
  background: transparent;
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
  line-height: 36px;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
  white-space: nowrap;
}

.meal-slot-segment-btn:hover:not(.active) {
  background: #e2e8f0;
  color: #334155;
}

.meal-slot-segment-btn.active {
  background: linear-gradient(135deg, #059669 0%, #10b981 55%, #34d399 100%);
  color: #fff;
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.35);
  transform: scale(1.02);
}

.meal-slot-segment-btn:focus {
  outline: none;
}

.meal-slot-segment-btn:focus-visible {
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.45);
}
</style>
